import ResendNda from './ResendNda.component';

export default ResendNda;